(function () {
  function closeAllMega(root) {
    root.querySelectorAll('[data-hn-mega-trigger][aria-expanded="true"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    root.querySelectorAll('[data-hn-mega-panel]').forEach(function (panel) {
      panel.hidden = true;
    });
  }

  function openMega(root, key) {
    if (!key) return;
    var trigger = root.querySelector('[data-hn-mega-trigger="' + key + '"]');
    var panel = root.querySelector('[data-hn-mega-panel="' + key + '"]');
    if (!trigger || !panel) return;
    closeAllMega(root);
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }

  function setupHeader(root) {
    if (!root || root.dataset.hnReady === 'true') return;
    root.dataset.hnReady = 'true';
    var closeTimer = null;

    function scheduleClose() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        closeAllMega(root);
      }, 160);
    }

    function cancelClose() {
      window.clearTimeout(closeTimer);
    }

    root.querySelectorAll('[data-hn-mega-trigger]').forEach(function (trigger) {
      var key = trigger.getAttribute('data-hn-mega-trigger');
      trigger.addEventListener('mouseenter', function () {
        cancelClose();
        openMega(root, key);
      });
      trigger.addEventListener('focus', function () {
        cancelClose();
        openMega(root, key);
      });
      trigger.addEventListener('mouseleave', scheduleClose);
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          openMega(root, key);
          var panel = root.querySelector('[data-hn-mega-panel="' + key + '"]');
          var firstLink = panel ? panel.querySelector('a[href]') : null;
          if (firstLink) firstLink.focus();
        }
      });
    });

    root.querySelectorAll('[data-hn-mega-panel]').forEach(function (panel) {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('focusin', cancelClose);
      panel.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!root.contains(document.activeElement)) closeAllMega(root);
        }, 0);
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAllMega(root);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllMega(root);
        closeDrawer(root);
      }
    });

    var openButton = root.querySelector('[data-hn-drawer-open]');
    var drawer = root.querySelector('[data-hn-mobile-drawer]');
    var panel = drawer ? drawer.querySelector('.hn-mobile-menu__panel') : null;
    if (openButton && drawer) {
      openButton.addEventListener('click', function () {
        drawer.hidden = false;
        openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('hn-mobile-menu-open');
        setTimeout(function () {
          if (panel) panel.focus();
        }, 0);
      });
    }

    root.querySelectorAll('[data-hn-drawer-close]').forEach(function (closeButton) {
      closeButton.addEventListener('click', function () {
        closeDrawer(root);
      });
    });
  }

  function closeDrawer(root) {
    var drawer = root.querySelector('[data-hn-mobile-drawer]');
    var openButton = root.querySelector('[data-hn-drawer-open]');
    if (!drawer) return;
    drawer.hidden = true;
    if (openButton) openButton.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('hn-mobile-menu-open');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hn-header-root]').forEach(setupHeader);
  });
})();
